// extracted by mini-css-extract-plugin
export var accordion = "_dy-0";
export var chevron = "_dy-3";
export var closed = "_dy-2";
export var content = "_dy-4";
export var open = "_dy-1";
export var rotate = "_dy-5";